module.exports = __webpack_public_path__ + "static/media/ui-ux.f145f96c.jpg";